import { Configuration } from '../../../../clients/quipli-service/configuration/configuration';

export type StatusTransition =
  | 'approve'
  | 'reject'
  | 'on-rent'
  | 'off-rent'
  | 'collect-payment'
  | 'quote'
  | 'inventory-return'
  | 'reopen'
  | 'missed';

export const shouldPaymentModalShow = (
  allowCombinedOffRentReturn: Configuration | undefined,
  currentStep: StatusTransition,
) => {
  const isInventoryReturnOrCombinedOffRentReturn =
    currentStep === 'inventory-return' ||
    (currentStep === 'off-rent' && allowCombinedOffRentReturn && allowCombinedOffRentReturn.value === '1');

  if (!isInventoryReturnOrCombinedOffRentReturn) {
    return false;
  }

  return true;
};
